export default __webpack_public_path__ + "static/media/fast-rewind-24-px-copy.1ea4c40d.svg";